import { textChangeRangeIsUnchanged, HighlightSpanKind } from "typescript";

export default class SalesDetailsReportController {
  constructor(ContentService, isMobile, $translate, moment) {
    this.service = ContentService;
    this.isMobile = isMobile;
    this.$translate = $translate;
    this.moment = moment;
  }

  $onInit() {
    const _ = this.$translate.instant;

    this.subscriptions = [];

    this.temporalTableFrom = undefined;
    this.temporalTableTo = undefined;
    this.tableRanges = []

    this.temporalCashier = undefined;
    this.selectedCashiers = [];

    this.temporalCategory = undefined;
    this.selectedCategories = [];

    this.temporalTag = undefined;
    this.selectedTags = [];

    this.rows = [];

    this.csvHeaders = [
      _('Fecha'), _('Artículo'), _('Cantidad'), _('Precio'), _('Descontado'), _('BillDiscount'),
      _('Total Descontado'), _('Monto'), _('Camarero'), _('Mesa'), _('Tipo de Mesa'),
      _('Etiqueta'), _('Categoría'),
    ];
    this.csvHeaderOrder = [
      'date', 'item', 'sold_qty', 'item_price', 'sold_discount', 'sold_billdiscount',
      'total_discount', 'sold_total', 'cashier', 'table', 'table_type', 'tag', 'family'
    ];

    this.dateFrom = undefined;
    this.dateTo = undefined;

    this.orderedBy = undefined;
    this.inMobileView = this.isMobile.phone;
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getChashiersMatching(searchTerm) {
    return this.service.getCashiersBySearchTerm(searchTerm).toPromise();
  }
  cashierRepr(cashier) {
    return !!cashier ? `${cashier.code} - ${cashier.name || '(Nada)'}` : '';
  }
  onCashierSelected(item, model, label, event) {
    this.temporalCashier = undefined;
    this.selectedCashiers.push(item);
  }
  removeCashier(cashierToRemove) {
    this.selectedCashiers.splice(
      this.selectedCashiers.findIndex((cashier) => cashier.id === cashierToRemove.id), 1
    );
  }

  getCategoriesMatching(searchTerm) {
    return this.service.getCategoriesBySearchTerm(searchTerm).toPromise();
  }
  categoryRepr(category) {
    return !!category ? `${category.name || '(Nada)'}` : '';
  }
  onCategorySelected(item, model, label, event) {
    this.temporalCategory = undefined;
    this.selectedCategories.push(item);
  }
  removeCategory(categoryToRemove) {
    this.selectedCategories.splice(
      this.selectedCategories.findIndex((category) => category.id === categoryToRemove.id), 1
    );
  }

  getTagsMatching(searchTerm) {
    return this.service.getTagsBySearchTerm(searchTerm).toPromise();
  }
  tagRepr(tag) {
    return !!tag ? `${tag.name || '(Nada)'}` : '';
  }
  onTagSelected(item, model, label, event) {
    this.temporalTag = undefined;
    this.selectedTags.push(item);
  }
  removeTag(tagToRemove) {
    this.selectedTags.splice(
      this.selectedTags.findIndex((tag) => tag.id === tagToRemove.id), 1
    );
  }

  checkIfTableRangeFilled() {
    if (this.temporalTableFrom && this.temporalTableTo) {
      this.tableRanges.push(`${this.temporalTableFrom}-${this.temporalTableTo}`);

      this.temporalTableFrom = undefined;
      this.temporalTableTo = undefined;
    }
  }
  removeTableRange(tableRangeToRemove) {
    this.tableRanges.splice(
      this.tableRanges.findIndex((tableRange) => tableRange === tableRangeToRemove), 1
    );
  }

  getSoldTotal(saleDetail) { return saleDetail.sold_total; }
  getSoldDiscount(saleDetail) { return saleDetail.sold_discount; }
  getSoldBillDiscount(saleDetail) { return saleDetail.sold_billdiscount; }
  getTotalDiscount(saleDetail) { return saleDetail.total_discount; }

  resetFilters() {
    this.temporalTableFrom = undefined;
    this.temporalTableTo = undefined;
    this.tableRanges = []

    this.temporalCashier = undefined;
    this.selectedCashiers = [];

    this.temporalCategory = undefined;
    this.selectedCategories = [];

    this.temporalTag = undefined;
    this.selectedTags = [];

    this.rows = [];

    this.dateFrom = undefined;
    this.dateTo = undefined;

    this.orderedBy = undefined;
  }
  generateReport() {
    this.subscriptions.push(
      this.service.getSalesDetails(
        this.dateFrom.format(), this.dateTo.format(),
        this.tableRanges,
        this.selectedCashiers.map(cashier => cashier.id),
        this.selectedCategories.map(category => category.id),
        this.selectedTags.map(tag => tag.id)
      ).subscribe(results => this.rows = results)
    );
  }

  getExportRows() {
    console.log(this.rows);

    return this.rows.map(row => {
      var newRow = angular.copy(row, {});
      if (newRow.date) {
        newRow.date = this.moment(newRow.date).format('DD/MM/YYYY');
      }
      return newRow;
    });
  }
}

SalesDetailsReportController.$inject = ['ContentService', 'isMobile', '$translate', 'moment'];



// WEBPACK FOOTER //
// ./src/app/pages/sales-details-report/sales-details-report.controller.js